import React, { useCallback } from "react"

import {
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"

import type {
  TraceSpanNameFilterConfig,
  TraceSpanNameOperator,
} from "@/types/metrics/metadata"

import { TRACE_SPAN_NAME_OPERATORS } from "../types"

interface SpanNameFilterEditorProps {
  filter: TraceSpanNameFilterConfig
  onChange: (filter: TraceSpanNameFilterConfig) => void
}

export const SpanNameFilterEditor: React.FC<SpanNameFilterEditorProps> = ({
  filter,
  onChange,
}) => {
  const handleOperatorChange = useCallback(
    (operator: string) => {
      onChange({ ...filter, operator: operator as TraceSpanNameOperator })
    },
    [filter, onChange],
  )

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...filter, value: event.target.value })
  }

  return (
    <div className="flex items-center gap-2">
      <Select value={filter.operator} onValueChange={handleOperatorChange}>
        <SelectTrigger className="w-32" aria-label="Span name operator">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {TRACE_SPAN_NAME_OPERATORS.map((operator) => (
            <SelectItem key={operator.value} value={operator.value}>
              {operator.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Input
        type="text"
        value={filter.value}
        onChange={handleValueChange}
        placeholder="llm"
        aria-label="Span name value"
        className="flex-1"
      />
    </div>
  )
}
